const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]'])
const PRODUCTION_LIKE_MODES = new Set(['production', 'development-prod'])

export const isLocalRuntime = () => {
  if (typeof window === 'undefined') return false

  const { hostname } = window.location

  return LOCAL_HOSTNAMES.has(hostname) || hostname.endsWith('.localhost')
}

export const isLocalProductionMode = () =>
  isLocalRuntime() && PRODUCTION_LIKE_MODES.has(import.meta.env.MODE)
